import { faBox } from '@fortawesome/pro-regular-svg-icons'
import { Avatar, type AvatarProps } from '@mantine/core'

import {
  type CoreBundleItem,
  type CoreBundle,
  type CoreItem,
  type CoreBundleItemPayload,
} from '@flecto/types'
import { getImageUrl } from '@flecto/utils'

import { Icon } from '..'

export type AvatarItemProps = AvatarProps & {
  item?: CoreItem | CoreBundle | CoreBundleItem | CoreBundleItemPayload
}

export function AvatarItem({ item, ...props }: AvatarItemProps) {
  const url =
    (item as CoreItem)?.photos?.[0]?.links?.photo_url ??
    (item as CoreBundle)?.main_photo ??
    (item as CoreBundleItem)?.item?.main_photo ??
    null

  const image = url ? getImageUrl(url) : undefined

  return (
    <Avatar size='md' {...props} radius='sm' src={image}>
      <Icon icon={faBox} data-testid='avatar-icon' />
    </Avatar>
  )
}
